export const TERMS_OF_USE = 'TERMS_OF_USE';
export const WEB_PREFERENCE_CENTER = 'PREFERENCE_CENTER';
export const PRIVACY_NOTICE = 'PRIVACY_NOTICE';
